<template>
  <div class="delivery">
    <el-container style="height: 100%;min-height:100vh;" direction="vertical">
      <el-header >
        <span style="font-size: 24px;">社区配送服务解决方案</span>
      </el-header>
      <el-main>
        <el-row>
          <span style="font-size: 20px;">应用场景</span>
          <p>社区配送服务主要针对针对自有社区微商服务平台业务进行配送服务。如下图所示</p>
        </el-row>
        <el-row>
          <img width="600px" height="300px" src="@/assets/image/delivery_service1.png">
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  data () {
    return {
      envData: [{
        id: '1',
        module: '环境动环监测',
        desc: '提供对环境量的实时监测、统计查询、报警检测'
      }, {
        id: '2',
        module: '污染源监测',
        desc: '提供对企业排污（废水、废气和固废等）的实时监测、统计查询、报警检测'
      }, {
        id: '3',
        module: '排污企业名录',
        desc: '提供对园区排污企业名录的实时监测、统计查询'
      }, {
        id: '4',
        module: '污染源名录',
        desc: '提供对园区排污企业建立污染源名录库，对污染源进行分类分级管理'
      }, {
        id: '5',
        module: '运维管理',
        desc: '解决传统运维过程中存在的“管不到、管不全、管不好”的难题'
      }, {
        id: '6',
        module: '视频监控',
        desc: '实现了实时监控、录像回放、图片查询及电视墙等应用'
      }, {
        id: '7',
        module: '污染源溯源',
        desc: '实现对超标报警、呆滞、离线、异常、故障等数据进行溯源分析'
      }, {
        id: '8',
        module: '预警分析',
        desc: '通过对企业的排污指标数据进行大数据分析预警'
      }, {
        id: '9',
        module: '应急管理',
        desc: '通过组织政府监管人员、运维人员、企业负责人和应急专家多方联合，合理建设应急物资装备库来处理突发应急事件'
      }],
      envProblem: [{
        id: '1',
        desc: '提升企业现场智能监管能力，防止无关人员随意进出，篡改监测数据，干扰监测系统正常运行'
      }, {
        id: '2',
        desc: '实现与污染源监测系统智能联动，对企业排污口需进行 24 小时不间断监管'
      }, {
        id: '3',
        desc: '借助先进的技术手段，实现污染源远程监管，提升环境监察执法的突击性和效率'
      }, {
        id: '4',
        desc: '借助先进的算法和数据分析手段，实现污染源排放预警，根治企业偷排、漏排问题'
      }, {
        id: '5',
        desc: '借助先进的信息化技术手段，解决基层环保人员编制不足，环保督察任务重，疲于奔命的问题'
      }]
    }
  }
}
</script>

<style lang="less" scoped>
body {
  margin: 0px;
}
.delivery {
  margin: 0px;
  padding: 0px;
}
.el-row {
  margin-top: 10px;
  padding-top: 10px;
}
.el-table {
  margin-left: 50px;
  margin-right: 50px;
  width: 800px;
}
</style>
